import React from 'react';

interface CircularProgressProps {
  percent: number;
  label?: string;
  size?: number;
  strokeWidth?: number;
}

// Vong tron tien trinh (fill mau theo %, so % o giua) dung cho cot trang thai man Lap ke hoach khi
// dang sinh vé/QR hoac export — thay cho thanh Progress ngang cua reactstrap vi khong co san dang
// circular.
const CircularProgress: React.FC<CircularProgressProps> = ({ percent, label, size = 36, strokeWidth = 4 }) => {
  const clamped = Math.max(0, Math.min(100, percent || 0));
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (clamped / 100) * circumference;

  return (
    <div className="d-flex align-items-center gap-2">
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} style={{ flexShrink: 0 }}>
        <circle cx={size / 2} cy={size / 2} r={radius} fill="none" stroke="#e9ecef" strokeWidth={strokeWidth} />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke="#0ab39c"
          strokeWidth={strokeWidth}
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          strokeLinecap="round"
          transform={`rotate(-90 ${size / 2} ${size / 2})`}
          style={{ transition: 'stroke-dashoffset 0.4s ease' }}
        />
        <text x="50%" y="50%" textAnchor="middle" dominantBaseline="central" fontSize={size * 0.3} fill="#495057">
          {Math.round(clamped)}%
        </text>
      </svg>
      {label && <small className="text-muted">{label}</small>}
    </div>
  );
};

export default CircularProgress;
